import { render, staticRenderFns } from "./MessageDefect.vue?vue&type=template&id=22eedb35&"
import script from "./MessageDefect.vue?vue&type=script&lang=js&"
export * from "./MessageDefect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports